// THIS FILE SHOULD NOT BE IMPORTED. WEBPACK WILL TAKE CARE OF LOADING IT IF NEEDED.
// This file is only loaded in the browser, because Webpack has an alias set up to load this file instead of'./index.ts'. The server will use the original file.
const getApiBaseUrl = (basePath: string) => {
  const basePathWithSlash = basePath.startsWith('/') ? basePath : `/${basePath}`;
  return `${window.location.protocol}//${window.location.host}${basePathWithSlash}`;
};

export default getApiBaseUrl;
